export const V1_REQUEST_SSR_LIST = 'V1_REQUEST_SSR_LIST'

export default flightId => {
  return {
    type: V1_REQUEST_SSR_LIST,
    flightId,
  }
}
